import { State } from "../../redux/store"

export const subjectSelector = (state: State): string | undefined => state.login?.userProfile?.sub
export const accountIdSelector = (state: State): string | undefined => state.login?.userProfile?.account
export const tenantSelector = (state: State): string | undefined => state.login?.userProfile?.tenant
